import { SxProps } from '@mui/material';
import Button from '@mui/material/Button';
import { ReactElement } from 'react';

interface ButtonProps {
  title: string | ReactElement;
  isActive?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  endIcon?: React.ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  startIcon?: React.ReactNode;
  disabled?: boolean;
  sx?: SxProps;
}

const CustomButton = ({
  title,
  isActive = true,
  onClick,
  endIcon,
  startIcon,
  disabled = false,
  type = 'button',
  sx,
  variant = 'contained',
}: ButtonProps) => {
  const buttonSx = {
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 550,
    minWidth: 'fit-content',
    width: 'fit-content',
    whiteSpace: 'nowrap',
    color: 'white',
    ...(variant === 'contained' && {
      backgroundColor: '#1982BB',
    }),
        ...(variant === 'outlined' && {
      color: '#1982BB',
    }),
        ...(variant === 'text' && {
      color: '#1982BB',
    }),
    ...(isActive === false && {
      backgroundColor: '#ffffff',
      color: 'black',
    }),
    ...(disabled && {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    }),
    ...(sx && sx),
  };

  return (
    <Button
      variant={variant}
      size="large"
      type={type}
      onClick={onClick}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled}
      sx={buttonSx}
    >
      {title}
    </Button>
  );
};

export default CustomButton;
